import React, { useState } from "react";
import Type1 from "./comps/type1";
import Type2 from "./comps/type2";
import Type3 from "./comps/type3";

export default function Services() {
  const [active, setActive] = useState("1");

  const category = [
    {
      title: "Infrastructure Design",
      id: "1",
    },
    {
      title: "Information Modelling",
      id: "2",
    },
    {
      title: "QC/QA POLICY",
      id: "3",
    },
  ];

  const renderActiveContent = () => {
    switch (active) {
      case "1":
        return <Type1 />;
      case "2":
        return <Type2 />;
      case "3":
        return <Type3 />;
      default:
        return;
    }
  };

  return (
    <div className="sm:px-4 px-2">
      <h1 className="sub-heading mb-16 flex items-end justify-center tracking-tight font-bold text-center">
        Services
      </h1>
      <div className=" md:block hidden">
        <div className="flex flex-col gap-12">
          <div className="flex items-center justify-center gap-6 w-fit mx-auto rounded-full bg-gray-100 p-2">
            {category.map((cat, i) => {
              return (
                <div
                  key={i}
                  className={`med-text px-6 py-3 rounded-full flex items-center justify-center cursor-pointer font-medium transition-all duration-300 ${
                    active === cat.id ? "bg-dark text-white shadow-lg" : "hover:bg-gray-200"
                  }`}
                  onClick={() => {
                    setActive(cat.id);
                  }}
                >
                  {cat.title}
                </div>
              );
            })}
          </div>
          <div className="max-w-[1100px] w-full mx-auto *:p-6">
            {renderActiveContent()}
          </div>
        </div>
      </div>

      <div className="md:hidden flex flex-col gap-24">
        <div>
          <h1 className="med-text font-bold mb-12 text-bright text-center">
            1) Building & Infrastructure Design
          </h1>
          <Type1 />
        </div>

        <div>
          <h1 className="med-text font-bold mb-12 text-bright text-center">
            2) Building Information Modelling
          </h1>
          <Type2 />
        </div>

        <div>
          <h1 className="med-text font-bold mb-12 text-bright text-center">3) QC/QA POLICY</h1>
          <Type3 />
        </div>
      </div>
    </div>
  );
}
